import { render, staticRenderFns } from "./OrderDetailTable.vue?vue&type=template&id=4345a8e1"
import script from "./OrderDetailTable.vue?vue&type=script&lang=js"
export * from "./OrderDetailTable.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailTable.vue?vue&type=style&index=0&id=4345a8e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports